import $ from 'jquery';
import core from '../core';

/**
 * Setup
 */
function setup() {
    const $el = $('.js-header__menu');
    if (! $el.length) {
        return;
    }

    if ($('#wpadminbar').length) {
        // if (window.matchMedia('(max-width: 600px)').matches) {
        // $el.css('padding-top', '46px');
        // $('#filters').css('padding-top', '46px');
        // }
    }

    $(document.body).on('hide_menu', hideMenu)
    $(document.body).on('click', '.menu-item-has-children > a', toggleSubmenu);
    $el.on('show.bs.collapse', onShowMenu);
    $el.on('hide.bs.collapse', onHideMenu);
}

/**
 * Toggle submenu
 *
 * @param {Object} evt
 */
function toggleSubmenu(evt) {
    if (window.matchMedia('(min-width: 1024px)').matches) {
        return;
    }

    evt.preventDefault();

    const $target = $(evt.currentTarget);
    const $menu = $target.closest('.menu');
    const $menuItem = $target.closest('li');
    const $submenu = $menuItem.find('> ul');
    const isActive = $menuItem.hasClass('active');// || $menuItemEl.hasClass('current-menu-ancestor');

    let selector = $target.attr('href');
    selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, ''); // strip for ie7

    if (isActive && !selector) {
        window.location.href = $target.attr('href');
    } else {
        $menu.find('li').removeClass('active');
        $menuItem.toggleClass('active');

        $menu.find('.sub-menu').not($submenu).hide();
        $submenu.slideToggle(400, 'swing');
    }
}

/**
 * On show menu
 *
 * @param {Object} evt
 */
function onShowMenu(evt) {
    // console.log(evt, 'onShowMenu');
    // Menu.$bodyEl.addClass('overflow-hidden');
}

/**
 * On hide menu
 *
 * @param {Object} evt
 */
function onHideMenu(evt) {
    // console.log(evt, 'onHideMenu');
    // Menu.$bodyEl.removeClass('overflow-hidden');
}

/**
 * Hide menu
 *
 * @param {Object} evt
 */
function hideMenu(evt) {
    const $el = $('.js-header__menu');
    if (! $el.length) {
        return;
    }

    $el.collapse('hide');
}

core.Ready(setup);
